import { useEffect, useState } from "react";
import "./header.style.scss";
import { NavLink } from "react-router-dom";
import { Tooltip } from 'antd';


export const HeaderMiradas = () => {
  return null;
};
